<template>
    <card>
      <template class="card-header" slot="header">
        <h4 class="card-title">
          CPU Information
          <button v-if="!noRefresh" class="btn btn-link text-info pull-right" @click="$emit('refreshData')">
            <font-awesome-icon icon="sync"></font-awesome-icon>
          </button>
        </h4>
        <p class="card-category">General information about the CPU of the server.</p>
      </template>
      <table class="table table-borderless beast-info-table">
        <tr>
          <th class="beast-key">CPU Architecture:</th>
          <td class="beast-value">{{cpuInfo.arch}}</td>
        </tr>
        <tr>
          <th class="beast-key">CPU Count:</th>
          <td class="beast-value">{{cpuInfo.cpus.length}}</td>
        </tr>
        <tr>
          <th class="beast-key">CPU Model:</th>
          <td class="beast-value">{{cpuInfo.cpus[0].model}}</td>
        </tr>
        <tr>
          <th class="beast-key">CPU Frequency:</th>
          <td class="beast-value">{{cpuInfo.cpus[0].speed}} MHz</td>
        </tr>
      </table>
    </card>
</template>

<script>
export default {
  props: {
    cpuInfo: {
      type: Object,
      required: true
    },
    noRefresh: {
      type: Boolean,
      default: false
    }
  },
  name: "CPUInfo"
};
</script>

<style scoped>

</style>
